export default "__VITE_ASSET__i_uMh$WN__"